const COMPONENT_SCHEMA_COMPTABLE = {
  title: 'Schéma comptable',
  noSchemaComptable: 'Aucun schéma comptable sélectionné',
  creationSchemaComptable: 'Créer un schéma spécifique',
  informations: {
    libelle: 'Libellé :',
    title: 'Schéma comptable :',
    type: 'Type :',
    compteNormal: 'Compte normal : ',
    compteExport: 'Compte à l’export :',
    compteTvaDebit: 'Compte TVA debit ou attente :',
    compteTvaEncaissement: 'Compte TVA encaissement :',
    tvaSurEncaissement: 'Tva sur encaissement :',
    produitConstate: 'Produit constaté d’avance :',
    compteRemiseHorsRegie: 'Compte remise (hors régie) :',
    compteRemiseRegie: 'Compte remise régie :',
  },
  popUpSchemaComptable: {
    libelle: 'Libellé',
    title: 'Schéma comptable',
    type: 'Type',
    compteNormal: 'Compte normal',
    compteExport: 'Compte à l’export',
    compteTvaDebit: 'Compte TVA debit ou attente',
    tvaSurEncaissement: 'Tva sur encaissement',
    compteTvaDebitToolTip: 'Le symbole "%" sera remplacé par la clé comptable du régime de TVA',
    compteTvaEncaissement: 'Compte TVA encaissement',
    produitConstate: 'Produit constaté d’avance',
    compteRemiseHorsRegie: 'Compte remise (hors régie)',
    compteRemiseRegie: 'Compte remise régie',
    success: {
      add: 'Le schéma comptable a été ajouté avec succès.',
    },
    actions: {
      annuler: 'Annuler',
      ajouter: 'Ajouter',
    },
  },
  autocomplete: {
    noResult: 'Aucun résultat',
    search: 'Rechercher...',
  },
};

export default COMPONENT_SCHEMA_COMPTABLE;
